"use strict";

module.exports = function () {
    function FilterExpression(opName, args) {
        this.name = opName;
        this.args = args;
    }

    FilterExpression.prototype.toFilter = function (filterBuilder, argName) {
        var filterDef = {
            type: "expression",
            operator: this.name,
            field: argName,
            args: this.args
        };
        return filterDef;
    };
    return FilterExpression;
}();